<template>
  <div class="form-config-container">
    <el-form label-position="top" size="small">
      <el-form-item label="标签对齐方式">
        <el-select v-model="data.labelPosition">
          <el-option value="left" label="左对齐"></el-option>
          <el-option value="center" label="居中对齐"></el-option>
          <el-option value="right" label="右对齐"></el-option>
          <el-option value="top" label="顶部对齐"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="表单字段宽度">
        <el-input-number
          v-model="data.labelWidth"
          :min="0"
          :max="200"
          :step="10"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="组件尺寸">
        <el-radio-group v-model="data.size">
          <el-radio-button label="medium">medium</el-radio-button>
          <el-radio-button label="small">small</el-radio-button>
          <el-radio-button label="mini">mini</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="配置禁用">
        <el-radio-group v-model="data.disabled">
          <el-radio-button :label="true">禁用</el-radio-button>
          <el-radio-button :label="false">不禁用</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="表单查看">
        <el-radio-group v-model="data.justShow">
          <el-radio-button :label="true">查看</el-radio-button>
          <el-radio-button :label="false">填写</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="定义全局Class">
        <el-input v-model="data.customClass" clearable></el-input>
      </el-form-item>

      <el-form-item label="子页面">
        <el-row v-for="(page, key, index) in sonPages" :key="key">
          <el-col :span="2">{{ index + 1 }}</el-col>
          <el-col :span="18"
            ><el-input v-model="page.title" clearable></el-input
          ></el-col>
          <el-col :span="4">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
              @click="removePage(page)"
              style="margin-left: 5px"
            ></el-button
          ></el-col>
        </el-row>
        <el-button type="text" @click="addSonPage">新增子页面</el-button>
      </el-form-item>

      <el-form-item>
        <template slot="label">
          <span>隐藏中无字段配置修正</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="流程设计中数据权限的隐藏配置选择无会被设置成显示（默认情况），开启后，无会正确继承之前的配置"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-switch
          v-model="data.fixHiddenDom"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>

      <el-form-item>
        <el-button
          plain
          style="width: 100%"
          @click="handleAssociatedModelFieldsClick"
          >关联模型字段</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 关联模型 -->
    <AssociatedModelFieldsDialog
      :list="list"
      :sonPages="sonPages"
      :modelJson="modelJson"
      :visible.sync="associatedModelFieldsVisible"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import AssociatedModelFieldsDialog from './AssociatedModelFieldsDialog/index.vue'
export default {
  name: 'form-config',
  components: {
    AssociatedModelFieldsDialog,
  },
  props: ['data', 'sonPages', 'pageTab', 'list', 'modelJson'],
  data() {
    return {
      addSonPageName: '',
      selTab: this.pageTab,
      associatedModelFieldsVisible: false,
    }
  },
  methods: {
    removePage(page) {
      const targetName = page.key
      const tabs = this.sonPages
      let activeName = this.selTab
      if (activeName === targetName) {
        const tabsKeys = Object.keys(tabs)

        tabsKeys.forEach((tabName, index) => {
          const tab = tabs[tabName]
          if (tab.key === targetName) {
            const nextTabName = tabsKeys[index + 1] || tabsKeys[index - 1]
            const nextTab = tabs[nextTabName]
            if (nextTab) {
              activeName = nextTab.key
            } else {
              activeName = 'main'
            }
          }
        })
      }
      this.selTab = activeName
      this.$delete(this.sonPages, targetName)
    },
    addSonPage() {
      const key = new Date().getTime() + ''
      const title = '子页面-' + key
      const page = {
        key: key,
        title: title,
        list: [],
      }
      this.$set(this.sonPages, key, page)
    },
    handleAssociatedModelFieldsClick() {
      this.associatedModelFieldsVisible = true
    },
    handleSuccess(value) {
      this.$emit('success', value)
    },
  },
  watch: {
    pageTab(val) {
      this.selTab = val
    },
    selTab: {
      handler(val) {
        this.$emit('update:pageTab', val)
      },
      deep: true,
    },
  },
}
</script>
